const OBSERVATORY = {
  RAIN: {
    code: 1,
    name: "雨量"
  },
  STAGE: {
    code: 4,
    name: "水位"
  },
  STAGE_KIKI: {
    code: 5,
    name: "水位(危)"
  },
  DAM: {
    code: 7,
    name: "ダム"
  },
  CAMERA: {
    code: 30,
    name: "カメラ"
  },
  LIVECAMERA: {
    code: 50,
    name: "ｶﾒﾗ(動画)"
  },
  WIND: {
    code: 15,
    name: "風"
  }
};

const STAGES = {
  OUTBREAK: {
    label: "氾濫発生水位",
    color: "#000000"
  },
  DANGEROUS: {
    label: "氾濫危険水位",
    color: "#ad02ad"
  },
  EVACUATION: {
    label: "避難判断水位",
    color: "#ff2800"
  },
  WARNING: {
    label: "氾濫注意水位",
    color: "#f2e700"
  },
  STANDBY: {
    label: "水防団待機水位",
    color: "#008000"
  },
  START: {
    label: "観測開始水位",
    color: "#22b022"
  },
  NORMAL: {
    label: "平常",
    color: "#ffffff"
  },
  DEFICIT: {
    label: "休止・欠測等",
    color: "#aaaaaa"
  }
};

const MapPane = {
  ObservatoryMarkersLayer: {
    name: "observatory-markers-layer",
    zIndex: 600
  },
  BranchOfficeMarker: {
    name: "branch-office-marker",
    zIndex: 610
  }
};

export { OBSERVATORY, STAGES, MapPane };
